import React from "react";
import "./About.css";
import "../../../src/App.css";
import AboutLanding from "./AboutLanding";
import AboutPalace from "./AboutPalace";
import Horse from "./Horse";
import Maps from "./Maps";
import Places from "./Places";
import Videography from "./Videography";
import Ourrooms from "./Ourrooms";
import Experience from "./Experience";
const About = () => {
  return (
    <div className="about_main">
      <AboutLanding />
      <AboutPalace />
      <Horse />
      <Places />
      <Experience />
      <Ourrooms />
      <Videography />
      <Maps />
    </div>
  );
};

export default About;
